import { createSlice } from '@reduxjs/toolkit';

const initState = {
  initList: [],
  loading: false,
};

const BanThuocSlice = createSlice({
  name: 'BanThuoc',
  initialState: initState,
  reducers: {
    doFetchSupplyList: (_, action) => {},
    updateSupplyList: (state, action) => {
      state.initList = action.payload
    },
    //
    doSavePayment: (_, action) => {},
    doCancelPayment: (_, action) => {},
    //
    setLoadingSell: (state, action) => {
      state.loading = action.payload
    },
    resetSellSlice: () => initState,
  }
});

export const { doFetchSupplyList, updateSupplyList, setLoadingSell, doSavePayment, doCancelPayment, resetSellSlice } = BanThuocSlice.actions;

export const getSellData = (state) => state.QlyVienPhi.BanThuoc;

export default BanThuocSlice.reducer;